/* eslint-disable @typescript-eslint/no-unused-vars */
import { IPermissions, IGroupPermissionsItem } from 'src/services/auth/users'
import setValue from 'set-value'
import getValue from 'get-value'
import { camelCase, kebabCase } from 'change-case'
import { flatten } from 'flat'
import deepmerge from 'deepmerge'

export const convertPermissionToObjectKey = (permission: string) =>
  permission
    .split('.')
    .map((key) => camelCase(key))
    .join('.')

export const convertObjectKeyToPermission = (objectKey: string) =>
  objectKey
    .split('.')
    .map((route) => kebabCase(route))
    .join('.')

export const getPermissionsFlatten = (permissions: IPermissions): string[] => {
  const flat: Record<string, boolean> = flatten(permissions)

  return Object.keys(flat)
    .filter((rule) => flat[rule] === true)
    .map((rule) => convertObjectKeyToPermission(rule))
}

export const getPermissionStructure = (
  items: IGroupPermissionsItem[]
): IPermissions => {
  return items.reduce((objectPermission, item) => {
    if (item.type === 'group') {
      return deepmerge(objectPermission, getPermissionStructure(item.items))
    }
    if (item.permission) {
      if (
        item.type === 'simple-permission' ||
        item.type === 'per-item-permission'
      ) {
        const objectKey = convertPermissionToObjectKey(item.permission)

        const alreadyPerm = getValue(objectPermission, objectKey)

        if (alreadyPerm !== undefined) {
          if (alreadyPerm === false && item.enabled === true) {
            setValue(objectPermission, objectKey, item.enabled)
          }
        } else {
          setValue(objectPermission, objectKey, item.enabled)
        }
      }
    }

    return objectPermission
  }, {} as IPermissions)
}

export const getAllGroupsPermissionsStructure = (
  slugs: string[]
): IPermissions => {
  return (
    slugs.reduce((permissions, slug) => {
      setValue(permissions, convertPermissionToObjectKey(slug), true)

      return permissions
    }, {} as IPermissions) || ({} as IPermissions)
  )
}

export const getLocalPermissions = () => {
  const permissions: IPermissions = {}

  const allAccess = { index: true, update: true, store: true, destroy: true }
  const allAccessWithoutRemove = {
    index: true,
    update: true,
    store: true,
    destroy: false,
  }

  setValue(permissions, 'drive.files', {
    ...allAccessWithoutRemove,
    primary: true,
    template: true,
  })

  // Frontend-only permissions: a local `true` can never be denied by the backend,
  // so everything covered by backend slugs (templates, mail) must stay out of here
  setValue(permissions, 'communication.telegram', allAccess)
  setValue(permissions, 'communication.twilio', allAccess)
  setValue(permissions, 'communication.accounts', allAccess)

  return permissions
}
